export const SCIM_TOKEN_PREFIX = "3b_scim_";
